import React, {Component} from 'react';
import SGMateriaTable from '../../components/UI/Table/SGMaterialTable';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Round from "@material-ui/icons/FiberManualRecordRounded";
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded'
import CircularProgress from '@material-ui/core/CircularProgress';
import CancelRounded from '@material-ui/icons/CancelRounded';
import { withRouter } from 'react-router-dom';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment-timezone';

import AddDriver from "./AddDriver";
import BusinessFirstLoginStepper from "../Business/BusinessOnBoard/BusinessFirstLoginStepper";
import ChangePassword from "../../components/ChangePassword/ChangePassword";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import {
    handleAddHistoricEwdEventDialog,
    handleEditDriverOpenDialog,
    handleEditDriverDialogClose,
    makeSearchFoundStatusNull,
    getDriverList, manageEditDriverOpenDialog
} from '../../actions/Driver';
import {
    getBusinessMenus
  } from '../../actions/Sidebar';
import FormGroup from "@material-ui/core/FormGroup/FormGroup";
import axios from "../../axios";
import {toast} from "react-toastify";


class DriverList extends Component{    

      RegionTimeZone = {
        "VIC": "Australia/Victoria",
        "QLD": "Australia/Queensland",
        "NSW": "Australia/NSW",
        "TAS": "Australia/Tasmania",
        "ACT": "Australia/ACT",
        "SA" :  "Australia/South",
        "NT" :  "Australia/North",
        "BROKEN_HILL" : "Australia/Broken_Hill",
        "EUCLA" : "Australia/Eucla",
        "WA" : "Australia/West"        
    }

    state = { isOpenHistoricalEwdDialog: false, isOpenSearchHistoricDialog: false, date: new Date(), currentHistoricEvents: [] , isOpenEwdSubscriptionDialog: false };

    onChange = date => this.setState({ date })

    navigateToDriverMedicalTeatmentRecord = (rowData, url) => {
        let actulaURL = '';
        localStorage.setItem('driver_id', rowData.id)
        if(url.indexOf(":driverid") >= 0){
            actulaURL = url.replace(":driverid",localStorage.getItem('driver_id'));
        }
        if(actulaURL !== ''){
            url = actulaURL;
        }
        this.props.history.push(url);
    }
    navigateToDriverExternalSystemRecord = (rowData, url) => {
        let actulaURL = '';
        localStorage.setItem('_driver_id', rowData._id)
        localStorage.setItem('driver_id', rowData.id)
        if(url.indexOf(":driverid") >= 0){
            actulaURL = url.replace(":driverid",localStorage.getItem('driver_id'));
        }
        if(actulaURL !== ''){
            url = actulaURL;
        }
        this.props.history.push(url);
    }
    changeDriverStatusColour = (data) => {       
        var status = data['linkStatus'];        

        if(status != undefined){
            if(status === 'PENDING'){
                data['statusIcon'] = <Round style={{ color: 'yellow' }}/>
             }else if((status.indexOf('DELINKED') != -1) || status.indexOf('DRIVER DECLINED') != -1 ){
                data['statusIcon'] = <CancelRounded style={{ color: 'red' }} />
             }else if(status.indexOf('DELINKED') === -1 && status.indexOf('LINKED') != -1 ){
                 if(data.driver_is_contractor){
                    data['statusIcon'] = <CheckCircleRoundedIcon style={{ color: 'purple' }} />
                 }else{
                    data['statusIcon'] = <CheckCircleRoundedIcon style={{ color: 'green' }} />
                 }
                
             } 
        }        
       
        return data;
    }
    componentDidMount(){
        this.props.getBusinessMenus(this.props);
        this.props.getDriverList();
    } 
  
   
    navigateToSearchDriver = (url) => {
        this.props.makeSearchFoundStatusNull();
        this.props.history.push(url);
    }

    openViewHistoricalEwdDialog = (driverInfo) => {
        this.setState({ isOpenSearchHistoricDialog: true });
        this.setState({ driverInfo: driverInfo });
        // Get
        let reqUrl = '/drivers/' + driverInfo.id + '/ewdevents';
        let headers = {'Authorization': localStorage.getItem('token')};
        axios.get(reqUrl, {headers}).then(response => {
            let driversLocal = response ? (response.data ? response.data.data : []) : [];
            let historicOrigin = [];
            driversLocal.forEach(e => {
                if (e.origin == 'Historic') {
                    if (e.eventStatus == 'D')
                        e.eventStatus = 'Deleted';
                    else if (e.eventStatus == 'N')
                        e.eventStatus = 'New';

                    e.time = e.device_datetime_offset;//moment(e.device_datetime_offset).format("HH:mm");

                    historicOrigin.push(e);
                }
            })
            this.setState({currentHistoricEvents: historicOrigin});
        }).catch(error => {
            toast.error(error.response.data.message, {
                containerId: 'toastMsg',
            });
        })
    }

    markHistoricEventAsDeleted = (ewdInfo) => {
        let ewdArray = [{
            "operation_type": "U",
            "vehicle_id": ewdInfo.vehicle_id,
            "event_type": ewdInfo.event_type,
            "device_datetime_offset": ewdInfo.device_datetime_offset,
            "created_time": ewdInfo.created_time,
            "location": ewdInfo.location,
            "odometer": ewdInfo.odometer + "",
            "comments": ewdInfo.comments,
            "entry_type": ewdInfo.entry_type,
            "fatigue_type": ewdInfo.fatigue_type,
            "is_breach": false,
            "is_tampered": false,
            "event_id": ewdInfo.event_id,
            "city": ewdInfo.city,
            "state": ewdInfo.state,
            "severity": ewdInfo.severity,
            "eventStatus": "D",
            "annotation": {},
            "isLocked": true,
            "vehicleType": ewdInfo.vehicleType,
            "latitude": ewdInfo.latitude + "",
            "longitude": ewdInfo.longitude + "",
            "driver_id": this.state.driverInfo.id,
            "homeBaseTimeZone": ewdInfo.homeBaseTimeZone ? ewdInfo.homeBaseTimeZone : '',
            "buildVersion": ewdInfo.buildVersion,
            "platformUser": localStorage.getItem('Platform-User')}];
        let reqURL = "/drivers/ewdevents";
        axios.post(reqURL, ewdArray, {'Authorization': localStorage.getItem('token'), 'Content-Type': 'application/json'}).then(response => {
            toast.success("Historic EWD Event is marked Deleted.", {
                containerId: 'toastMsg',
            });
            this.setState({ isOpenSearchHistoricDialog: false });
        }).catch(error => {
            toast.error(error.response.data.message, {
                containerId: 'toastMsg',
            });
        });
    }

    closeViewHistoricalEwdDialog = () => {
        this.setState({ isOpenSearchHistoricDialog: false });
        this.setState({ currentHistoricEvents: [] });
    }

    openHistoricalEwdDialog = (driverInfo) => {
        this.setState({ isOpenHistoricalEwdDialog: true });
        this.setState({ driverInfo: driverInfo });
    }

    closeHistoricalEwdDialog = () => {
        this.setState({ isOpenHistoricalEwdDialog: false });
    }

    openEwdSubscriptionDialog = (driverInfo) => {
        this.setState({ isOpenEwdSubscriptionDialog: true });
        this.setState({ driverInfo: driverInfo });
    }

    closeEwdSubscriptionDialog = () => {
        this.setState({ isOpenEwdSubscriptionDialog: false });
    }

    saveHistoricEwdDialog = () => {
   
        let region = this.RegionTimeZone[this.state.driverInfo.homeBaseTimeZone]       

        if (this.state.vehicleId.value && this.state.vehicleId.value != '' && this.state.activity.value && this.state.activity.value != '' &&
            this.state.location.value && this.state.location.value != '' && this.state.odometer.value && this.state.odometer.value != '' &&
            this.state.comments.value && this.state.comments.value != '' && this.state.wrOption.value && this.state.wrOption.value != '' ) {
                //Set device date time as per drivers homebase timezone
            let ewdArray = [{"operation_type": "I",
                "vehicle_id": this.state.vehicleId.value,
                "event_type": this.state.activity.value,
                "device_datetime_offset": region == undefined ? moment(this.state.date.getTime()).format('YYYY-MM-DDTHH:mm:ssZ') : moment(this.state.date.getTime()).tz(region).format('YYYY-MM-DDTHH:mm:ssZ'),               
                "created_time":region == undefined ? moment(new Date().getTime()).format('YYYY-MM-DDTHH:mm:ssZ') : moment(new Date().getTime()).tz(region).format('YYYY-MM-DDTHH:mm:ssZ'),
                "location": this.state.location.value,
                "odometer": this.state.odometer.value,
                "comments": this.state.comments.value,
                "entry_type": "Record Keeper",
                "origin": 'Historic',
                "fatigue_type": this.state.wrOption.value,
                "is_breach": false,
                "is_tampered": false,
                "event_id": this.state.driverInfo.id + '-' + new Date().getTime(),
                "city": this.state.location.value,
                "state": this.state.driverInfo.baseLocation ? this.state.driverInfo.baseLocation : '',
                "eventStatus": "N",
                "vehicleType": "HEAVY_VEHICLE",
                "latitude": "0",
                "longitude": "0",
                "driver_id": this.state.driverInfo.id,
                "homeBaseTimeZone": this.state.driverInfo.homeBaseTimeZone ? this.state.driverInfo.homeBaseTimeZone : '',
                "buildVersion": "",
                "isLocked": true,
                "platformUser": localStorage.getItem('Platform-User')}];
            let reqURL = "/drivers/ewdevents";
            axios.post(reqURL, ewdArray, {'Authorization': localStorage.getItem('token'), 'Content-Type': 'application/json'}).then(response => {
                toast.success("Historic EWD Event is saved.", {
                    containerId: 'toastMsg',
                });
                // Clear all field values
                this.state.vehicleId.value = '';
                this.state.activity.value = '';
                this.state.wrOption.value = '';
                this.state.location.value = '';
                this.state.odometer.value = '';
                this.state.comments.value = '';
                this.setState({date: new Date()});
            }).catch(error => {
                toast.error(error.response.data.message, {
                    containerId: 'toastMsg',
                });
            })
        } else {
            toast.error("Please fill up all the fields in the form.", {
                containerId: 'toastMsg',
            });
        }

    }

    render(){
        let historicColumns = [
            {

                title: 'Event Status',
                field: 'eventStatus'
            },
            {
                title: 'Time',
                field: 'time'
            },
            {
                title: 'Activity',
                field: 'event_type'
            },
            {
                title: 'Location',
                field: 'location'
            },
            {
                title: 'Odometer',
                field: 'odometer'
            },
            {
                title: 'Registration',
                field: 'vehicle_id'
            },
            {
                title: 'W/R Option',
                field: 'fatigue_type'
            },
            {
                title: 'Comments',
                field: 'comments'
            },
            {
                title: 'Origin',
                field: 'origin'
            },
            {
                title: 'Entry Timestamp',
                field: 'created_time_offset'
            },
            {
                title: 'Entry Type',
                field: 'entry_type'
            }
        ];
        let {
            openEditDriverDialogStatus,
            driverInfoCols,
            driverInformations,
            showListDriverLoaderStatus
        } = this.props.driverState;
        let{
            menuItems
        } = this.props.sidebarState;
        let{
            userFirstLoginStatus
        } = this.props.changePasswordState;
        let mainUrl;
        if(localStorage.getItem('role') === '1'){
            mainUrl = ((window.location.pathname).split('/'))[6];
        }
        if(localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '4'){
            mainUrl = ((window.location.pathname).split('/'))[5];
        }
        if(localStorage.getItem('role') === '5' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7'){
            mainUrl = ((window.location.pathname).split('/'))[3];
        }
        return(

            <div className = "container">
                <Dialog
                    open={localStorage.getItem('role') !== '5' && userFirstLoginStatus === 'true'}
                    maxWidth = 'sm'
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <ChangePassword/>
                </Dialog>
                <div>
                    <BusinessFirstLoginStepper />
                </div>

                <div className = "mt-4 mb-5">
                    <Paper>
                        <Grid container spacing = {24} style = {{paddingLeft : "1rem", paddingTop : "0", paddingRight : "1rem"}}>
                            <Grid item xs = {6} style = {{paddingTop : "0"}}>
                                <h4 style = {{marginTop : "1rem", textTransform : "uppercase"}}>Driver List</h4>
                            </Grid>

                            <Grid item xs = {6} style = {{display : "flex", justifyContent : "flex-end", paddingBottom : "2rem"}}>
                                {
                                    mainUrl !== 'mtdriverlist' && mainUrl !== 'esdriverlist' ?
                                    <div>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick = {() => this.navigateToSearchDriver(menuItems['driver_search'].urlpattern)}
                                        >
                                            <i className="material-icons" style = {{paddingRight : "0.5rem"}}>
                                                add_circle_outline
                                            </i>
                                            Add Driver
                                        </Button>
                                    </div> : null
                                }

                            </Grid>
                        </Grid>
                        {
                            showListDriverLoaderStatus || openEditDriverDialogStatus ?
                            <div style = {{height : "30rem"}} className = "d-flex justify-content-center align-items-center">
                                <CircularProgress color = "primary" />                                
                            </div>
                                :
                            <SGMateriaTable
                                title=""
                                columns={driverInfoCols}
                                data={driverInformations != undefined ? driverInformations.map((d) => this.changeDriverStatusColour(d)) : driverInformations}                             
                                actions={mainUrl === 'mtdriverlist' ? [
                                    {
                                        icon: 'local_hospital',
                                        tooltip: 'Add Medical Treatment',
                                        onClick: (event, rowData) => this.navigateToDriverMedicalTeatmentRecord(rowData, menuItems['medical_treatment_list'].urlpattern)
                                    }
                                    ] : mainUrl === 'esdriverlist' ? [
                                        {
                                            icon: 'computer',
                                            tooltip: 'Add External System',
                                            onClick: (event, rowData) => this.navigateToDriverExternalSystemRecord(rowData, menuItems['external_driver_list'].urlpattern)
                                        }
                                        ] :
                                        [ 
                                            {
                                                icon: 'edit',
                                                tooltip: 'Edit Driver',
                                                onClick: (event, rowData) => this.props.handleEditDriverOpenDialog(rowData)
                                            },
                                            {
                                                icon: 'insert_chart',
                                                tooltip: 'View Historic EWD Events',
                                                onClick: (event, rowData) => this.openViewHistoricalEwdDialog(rowData)
                                            },
                                            {
                                                icon: 'addchart',
                                                tooltip: 'Add Historic EWD Event',
                                                onClick: (event, rowData) => this.openHistoricalEwdDialog(rowData)
                                            }
                                        ]

                                }

                                
                            />
                        }

                    </Paper>
                </div>

                <Dialog
                    open={openEditDriverDialogStatus}
                    onClose={() => {this.props.handleEditDriverDialogClose()}}
                    maxWidth = 'md'
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <AddDriver/>
                </Dialog>

                <Dialog
                    open={this.state.isOpenSearchHistoricDialog}
                    onClose={() => {this.closeViewHistoricalEwdDialog()}}
                    maxWidth = 'md'
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                        <div style={{"margin-left": "30px", "margin-right": "30px", "margin-bottom": "30px"}}>
                            <h4>Historic EWD Events of&nbsp;{this.state.driverInfo ? this.state.driverInfo.driver_firstname : ''}&nbsp;{this.state.driverInfo ? this.state.driverInfo.driver_lastname : ''}</h4>
                            <FormGroup row>
                                <SGMateriaTable
                                    title=""
                                    columns={historicColumns}
                                    data={this.state.currentHistoricEvents}
                                    actions={[{ icon: 'delete', tooltip: 'Mark as Deleted', onClick: (event, rowData) => this.markHistoricEventAsDeleted(rowData)}]}/>
                            </FormGroup>
                            <br/>
                            <button className="MuiButtonBase-root MuiButton-root MuiButton-contained mr-3"
                                    onClick={() => this.closeViewHistoricalEwdDialog()}>Close
                            </button>
                        </div>
                </Dialog>

                <Dialog
                    open={this.state.isOpenHistoricalEwdDialog}
                    onClose={() => {this.closeHistoricalEwdDialog()}}
                    maxWidth = 'md'
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <FormGroup row>
                        <div style={{"margin-left": "30px", "margin-right": "30px", "margin-bottom": "30px"}}>
                            <h4>Add Historic EWD Event</h4>
                            <span style={{"color": "#6c757d"}}>Activity</span><br/>
                            <select ref={el => this.state.activity = el}>
                                <option value="Work">Work</option>
                                <option value="Rest">Rest</option>
                            </select><br/>
                            <span style={{"color": "#6c757d"}}>Location</span><br/>
                            <input id="location" ref={el => this.state.location = el}/><br/>
                            <span style={{"color": "#6c757d"}}>Time of Activity</span><br/>
                            <DateTimePicker onChange={this.onChange} format='dd/MM/yyyy HH:mm' value={this.state.date}/><br/>     
                            <DatePicker
                                selected={new Date()}                              
                                dateFormat="MM/yyyy"
                                showMonthYearPicker                           
                            />                            
                            <span style={{"color": "#6c757d"}}>Vehicle Id</span><br/>
                            <input id="vehicleId" ref={el => this.state.vehicleId = el}/><br/>
                            <span style={{"color": "#6c757d"}}>Odometer</span><br/>
                            <input id="odometer" ref={el => this.state.odometer = el}/><br/>
                            <span style={{"color": "#6c757d"}}>W/R Option</span><br/>
                            <select ref={el => this.state.wrOption = el}>
                                <option value="Standard Heavy">Standard Heavy</option>
                                <option value="Standard Bus">Standard Bus</option>
                                <option value="Standard 2-Up">Standard 2-Up</option>
                                <option value="BFM">BFM</option>
                                <option value="BFM 2-up">BFM 2-up</option>
                                <option value="AFM">AFM</option>
                                <option value="AFM 2-up">AFM 2-up</option>
                            </select><br/>
                            <span style={{"color": "#6c757d"}}>Comments</span><br/>
                            <input id="comments" ref={el => this.state.comments = el} maxLength={400}/>
                            <br/><br/>
                            <button class="MuiButtonBase-root MuiButton-root MuiButton-contained mr-3 MuiButton-containedPrimary"
                                    onClick={() => this.saveHistoricEwdDialog()}>Save
                            </button>
                            <button class="MuiButtonBase-root MuiButton-root MuiButton-contained mr-3" onClick={() => this.closeHistoricalEwdDialog()} >Close</button>
                        </div>
                    </FormGroup>
                </Dialog>
               
            </div>
        )
    }

}
const mapStateToProps = state => {
    return{
        driverState : state.driver,
        sidebarState : state.sidebarState,
        changePasswordState : state.changePassword
    }
}
const matDispatchToProps = (dispatch) => {
    return{
        handleAddHistoricEwdEvent: (rowData) => {
            return dispatch(handleAddHistoricEwdEventDialog(rowData))
        },
        handleEditDriverOpenDialog : (rowData) => {
            return dispatch(handleEditDriverOpenDialog(rowData))
        },
        handleEditDriverDialogClose : () => {
            return dispatch(handleEditDriverDialogClose())
        },
        makeSearchFoundStatusNull : () => {
            return dispatch(makeSearchFoundStatusNull())
        },
        getDriverList : (businessId) => {
            return dispatch(getDriverList(businessId))
        },
        getBusinessMenus : (props) => {
            return dispatch(getBusinessMenus(props))
        }
    }
}
export default connect(mapStateToProps, matDispatchToProps)(withRouter(DriverList));
